import { NgModule } from '@angular/core';
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { SliderModule } from "primeng/slider";
import { DatePickerModule } from "primeng/datepicker";
import { InputTextModule } from "primeng/inputtext";
import {CheckboxModule} from 'primeng/checkbox';
import { MenubarModule } from 'primeng/menubar';
import { PanelModule } from "primeng/panel";
import { SelectModule } from "primeng/select";
import { TooltipModule } from "primeng/tooltip";
import {RadioButtonModule} from 'primeng/radiobutton';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputGroupModule} from 'primeng/inputgroup';
import {InputGroupAddonModule} from 'primeng/inputgroupaddon';
import {DialogModule} from 'primeng/dialog';
import {EditorModule} from 'primeng/editor';
import {FileUploadModule} from 'primeng/fileupload';
import {ProgressBarModule} from 'primeng/progressbar';
import {CardModule} from 'primeng/card';
import {ListboxModule} from 'primeng/listbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {ToastModule} from 'primeng/toast';
import {ContextMenuModule} from 'primeng/contextmenu';

import { MessageModule } from 'primeng/message';
import { TabsModule } from "primeng/tabs";
import {ToolbarModule} from 'primeng/toolbar';
import { TextareaModule } from "primeng/textarea";
import {PasswordModule} from 'primeng/password';
import {DividerModule} from 'primeng/divider';
import {DragDropModule} from 'primeng/dragdrop';
import { DialogService } from 'primeng/dynamicdialog';
import {InputMaskModule} from 'primeng/inputmask';
import {SplitButtonModule} from 'primeng/splitbutton';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { PopoverModule } from "primeng/popover";
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FieldsetModule } from 'primeng/fieldset';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { DrawerModule } from 'primeng/drawer';
import { TreeTableModule } from 'primeng/treetable';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';

import { SkeletonModule } from 'primeng/skeleton';
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { TagModule } from 'primeng/tag';

@NgModule({
    imports: [
        TableModule,
        ButtonModule,
        SliderModule,
        DatePickerModule,
        InputTextModule,
        CheckboxModule,
        MenubarModule,
        PanelModule,
        SelectModule,
        TooltipModule,
        RadioButtonModule,
        ScrollPanelModule,
        ProgressSpinnerModule,
        ConfirmDialogModule,
        InputNumberModule,
        InputGroupModule,
        InputGroupAddonModule,
        DialogModule,
        EditorModule,
        FileUploadModule,
        ProgressBarModule,
        CardModule,
        ListboxModule,
        MultiSelectModule,
        ToastModule,
        ContextMenuModule,
        
        MessageModule,
        TabsModule,
        ToolbarModule,
        TextareaModule,
        PasswordModule,
        DividerModule,
        DragDropModule,
        InputMaskModule,
        SplitButtonModule,
        ConfirmPopupModule,
        PopoverModule,
        BreadcrumbModule,
        FieldsetModule,
        BadgeModule,
        BlockUIModule,
        DrawerModule,
        TreeTableModule,
        TreeModule,
        TreeSelectModule,
        
        SkeletonModule,
        ToggleSwitchModule,
        TagModule
    ],
    exports: [
        TableModule,
        ButtonModule,
        SliderModule,
        DatePickerModule,
        InputTextModule,
        CheckboxModule,
        MenubarModule,
        PanelModule,
        SelectModule,
        TooltipModule,
        RadioButtonModule,
        ScrollPanelModule,
        ProgressSpinnerModule,
        ConfirmDialogModule,
        InputNumberModule,
        InputGroupModule,
        InputGroupAddonModule,
        DialogModule,
        EditorModule,
        FileUploadModule,
        ProgressBarModule,
        CardModule,
        ListboxModule,
        MultiSelectModule,
        ToastModule,
        ContextMenuModule,
        
        MessageModule,
        TabsModule,
        ToolbarModule,
        TextareaModule,
        PasswordModule,
        DividerModule,
        DragDropModule,
        InputMaskModule,
        SplitButtonModule,
        ConfirmPopupModule,
        PopoverModule,
        BreadcrumbModule,
        FieldsetModule,
        BadgeModule,
        BlockUIModule,
        DrawerModule,
        TreeTableModule,
        TreeModule,
        TreeSelectModule,
        
        SkeletonModule,
        ToggleSwitchModule,
        TagModule
    ],
    providers: [
        DialogService
    ]
})
export class PrimengModule { }

